declare var Splide: any;

const voiceSplide = () => {
  const sliders = document.querySelectorAll('.js-voice-splide');

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: 'loop',
      drag: 'free',
      fixedWidth: '378px',
      gap: '32px',
      pagination: false,
      arrows: true,
      breakpoints: {
        767: {
          fixedWidth: '100%',
        },
      }
    });

    splide.mount();
  });
};

export default voiceSplide;
